package ai.wagemix.net.models

/** The outcome of creating a share link for a mix. */
interface WMShareResult {
    val mixId: String
    val sharedMixId: String
    val shareableUrl: String

    companion object
}

fun WMShareResult.Companion.of(mixId: String, sharedMixId: String, shareableUrl: String): WMShareResult {
    return WMShareResultData(mixId = mixId, sharedMixId = sharedMixId, shareableUrl = shareableUrl)
}

private data class WMShareResultData(
    override val mixId: String,
    override val sharedMixId: String,
    override val shareableUrl: String
): WMShareResult
